var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#151B26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2502 24.0002H2.75034C1.23333 24.0002 0.000488281 22.7671 0.000488281 21.2503V6.75034C0.000488281 5.23333 1.23333 4.00049 2.75034 4.00049H6.25037C6.66436 4.00049 7.00036 4.33648 7.00036 4.75048C7.00036 5.16448 6.66436 5.50047 6.25037 5.50047H2.75034C2.06132 5.50047 1.50047 6.06132 1.50047 6.75034V21.2503C1.50047 21.9392 2.06132 22.5002 2.75034 22.5002H21.2502C21.9392 22.5002 22.5003 21.9392 22.5003 21.2503V12.7503C22.5003 12.3363 22.8363 12.0003 23.2503 12.0003C23.6643 12.0003 24.0003 12.3363 24.0003 12.7503V21.2503C24.0003 22.7671 22.7672 24.0002 21.2502 24.0002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74889 15.9871C6.69396 15.9871 6.63885 15.9811 6.58392 15.967C6.24499 15.8881 6 15.5981 6 15.2502V13.7502C6 8.37425 10.374 4.00027 15.7499 4.00027H15.9998V0.750177C15.9998 0.444211 16.1859 0.169189 16.4699 0.0541999C16.7528 -0.0596906 17.0778 0.00915639 17.2898 0.230163L23.7898 6.9801C24.0698 7.27013 24.0698 7.73009 23.7898 8.02012L17.2898 14.7701C17.0778 14.9911 16.7507 15.0592 16.4699 14.946C16.1859 14.831 15.9998 14.556 15.9998 14.25V11.0001H14.8119C11.666 11.0001 8.83884 12.748 7.43297 15.5611C7.30388 15.8211 7.03289 15.9871 6.74889 15.9871ZM15.7499 5.50025C11.5499 5.50025 8.072 8.65513 7.56297 12.72C9.38083 10.6922 11.9879 9.50015 14.8119 9.50015H16.7498C17.1638 9.50015 17.4998 9.83615 17.4998 10.2501V12.3901L22.2087 7.50011L17.4998 2.61014V4.75026C17.4998 5.16426 17.1638 5.50025 16.7498 5.50025H15.7499Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default ForwardRef;